// src/components/homes/HomeDefault.js

import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";

import { FiFilePlus, FiFolder, FiUser } from "react-icons/fi";

import "./home-default.css";
import api from "api";
import HomepageCarrousel from "components/cms/templates/HomepageCarrousel";
import HomepageShortcuts from "components/cms/templates/HomepageShortcuts";
import CMSBlock from "components/cms/CMSBLock";
import FormalitiesTemplatesSearch from "components/formalities/helpers/FormalitiesTemplatesSearch";
export default function HomeDefault() {
  const navigate = useNavigate();
  const [page, setPage] = useState(null);
  const [loading, setLoading] = useState(true);
  useEffect(() => {
    api
      .get("/cms/home-default/contents")
      .then((res) => {
        setPage(res.data);
      })
      .finally(() => {
        setLoading(false);
      });
  }, []);
  if (loading) {
    return null; // ou spinner si tu veux
  }
  // récupération directe du premier bloc carrousel
  const carrouselBlock = page?.blocks?.find(
    (block) => block.type === "homepage_carrousel"
  );
  return (
    <div id="homepage-default" className="">
      {carrouselBlock && (
        <HomepageCarrousel articles={carrouselBlock.data.articles} />
      )}
      <section>
        <div className="bg-primary-20 py-5">
          <div className="section-title">
            <h2 className="mb-2">
              <span className="badge badge-sm bg-primary rounded-pill fw-normal mb-2 px-3 fs-7 text-uppercase">
                Rechercher une formalité
              </span>
            </h2>
          </div>
          <div className=" px-2 px-md-0">
            <FormalitiesTemplatesSearch />
          </div>


        </div>
      </section>
      <section className="py-5 mt-5 mb-5">
        <HomepageShortcuts />
      </section>
      <CMSBlock
        blockId="homepage-content-footer"
      />
    </div>
  );
}